import { WhatsappContextService } from 'common/service/whatsapp/context.service';

import { GalleryNudgeWhatsappComponentFactory } from './component.factory';

export const GalleryNudgeWhatsappComponent = GalleryNudgeWhatsappComponentFactory(WhatsappContextService());
